









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MentoringMeetingStatus extends Vue {
  @Prop({ type: String, default: '' })
  readonly type!: string;

  @Prop({ type: String, default: '' })
  readonly status!: string;

  @Prop({ type: String, default: 'normal' })
  readonly statusColor!: string;

  get colorStyle() {
    return `meetingstatus_${this.statusColor}`;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/modal/components/meeting/components/status/MentoringMeetingStatus.vue